import React, { Component } from 'react';
import { translate } from 'react-i18next';

import HomePage from 'components/HomePage/HomePage';

class Home extends Component {

  render() {
    return (
      <div className='app-container'>
        <HomePage />
      </div>
    );
  }
}

export default translate()(Home);
